/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FechaMinMaxReproModelDto } from '../../models/fecha-min-max-repro-model-dto';

export interface CitasControllerFechaMinMaxCrearCita$Params {
}

export function citasControllerFechaMinMaxCrearCita(http: HttpClient, rootUrl: string, params?: CitasControllerFechaMinMaxCrearCita$Params, context?: HttpContext): Observable<StrictHttpResponse<FechaMinMaxReproModelDto>> {
  const rb = new RequestBuilder(rootUrl, citasControllerFechaMinMaxCrearCita.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FechaMinMaxReproModelDto>;
    })
  );
}

citasControllerFechaMinMaxCrearCita.PATH = '/api/citas/fecha-min-max-crear-cita';
